import { render, staticRenderFns } from "./NavigationMenuItem.vue?vue&type=template&id=7f94ad69"
import script from "./NavigationMenuItem.vue?vue&type=script&lang=js"
export * from "./NavigationMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports